import { PostAPI } from 'Components/Helper/Helpers';

export const Add = async (request) => {
    return PostAPI(request, 'PaymentGatewaySender/Add');
};

export const VerifyOTP = async (request) => {
    return PostAPI(request, 'PaymentGatewaySender/VerifyOTP');
}; 